import React from "react";

export default function Subheader() {
  return (
    <div>
      <div class="fixed w-full top-0 z-10">
        <ul class=" list-none p-1 py-2 flex md:flex-row lg:right-0 lg:overflow-visible lg:h-full lg:w-auto lg:relative lg:border-0 lg:top-0 right-0 justify-end bg-blue-dark py-2">
          <li class="mr-auto ml-6">
            <a
              class="lg:hidden border border-white text-white text-12 content-start p-2"
              href="/schedule-consultation"
            >
              Schedule a Consultation
            </a>
          </li>
          <li class="">
            <a
              class="text-white text-11 lg:text-14 ml-2 pr-5 lg:pr-12 border-r lg:tracking-wider hover:underline"
              href="/mlo-search"
            >
              Find a Loan Officer
            </a>
          </li>
          <li class="">
            <a
              class="text-white text-11 lg:text-14 pr-5 lg:tracking-wider mr-4 ml-2 lg:pr-12 lg:pl-12 hover:underline"
              target="_blank"
              href="https://apply.onetrusthomeloans.com/#/"
            >
              Sign In
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
